import { styled } from "@mui/material/styles";

export const FileCardWrapper = styled("div")`
  height: calc(100% - 20px);
  cursor: zoom-in;
  width: 600px;
  max-width: 600px;
  margin-top: 20px;
  position: relative;

  @supports (-webkit-touch-callout: none) {
    overflow-y: auto;
    height: calc(100vh - 200px);
  }

  ${({ theme }) => theme.breakpoint.maxWidth.xs`
    width: 100%;
  `};

  .react-pdf__Page {
    margin-bottom: 20px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
  }
`;

export const ControlBar = styled("div", {
  label: "ControlBar",
  name: "ControlBar",
})`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  height: 60px;
  width: 100%;
  border-top: 1px solid #0014361a;
  background-color: white;
`;

export const PaginationWrapper = styled("div", {
  label: "PaginationWrapper",
  name: "PaginationWrapper",
})`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #e4e4e4;

  & .react-pdf__Document {
    cursor: zoom-in;
  }

  & .textLayer :is(span, br) {
    cursor: zoom-in;
  }

  @supports (-webkit-touch-callout: none) {
    width: 100% !important;
  }

  @media (max-height: 750px) {
    height: calc(100vh - 200px);
  }
`;

export const DocumentWrapper = styled("div", {
  label: "DocumentWrapper",
  name: "DocumentWrapper",
})`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: start;
  height: 100%;
  background-color: white;
  width: 100%;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .react-pdf__Page {
    margin-bottom: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }

  .react-pdf_message {
    padding: 20px;
    color: white;
  }
`;
